// import Vue from 'vue'
import firebase from 'firebase/app'

const config = {
	apiKey: process.env.VUE_APP_FIREBASE_KEY
	,authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN
	,databaseURL: process.env.VUE_APP_FIREBASE_DATABASE
	,projectId: process.env.VUE_APP_FIREBASE_PROYECT_ID
	,storageBucket: process.env.VUE_APP_FIREBASE_STORED
	,messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER
	,appId: process.env.VUE_APP_FIREBASE_APP_ID
}

firebase.initializeApp(config);
